import { createContext, useState } from "react";

export const HidePrayersContext = createContext({
  hidePrayers: null,
  setHidePrayers: () => null,
});

export const HidePrayersProvider = ({ children }) => {
  const [hidePrayers, setHidePrayers] = useState(null);
  const value = { hidePrayers, setHidePrayers };
  return (
    <HidePrayersContext.Provider value={value}>
      {children}
    </HidePrayersContext.Provider>
  );
};
